import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Undo2 } from "lucide-react";

const CHANNEL = { apple: "Apple petition", merchant_email: "Merchant email", bank_dispute: "Bank dispute" };

function ago(iso) {
  const d = (Date.now() - new Date(iso).getTime()) / 1000;
  if (d < 3600) return `${Math.max(1, Math.floor(d / 60))}m ago`;
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`;
  return `${Math.floor(d / 86400)}d ago`;
}

export default function RecoveryWall() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = () => api.get("/public/recovery-wall").then((r) => setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  if (!data) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-16 sm:pt-24" data-testid="recovery-wall">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <div className="font-mono text-[11px] uppercase tracking-widest text-[#00E676] flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[#00E676] live-dot" /> RECOVERY WALL · LIVE
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mt-3">Money that came back.</h2>
        </div>
        <div className="font-mono text-xs uppercase tracking-widest text-[#606872]" data-testid="recovery-wall-meta">
          {data.real_count > 0 ? `${data.real_count} real refunds landed · $${data.real_total.toFixed(2)} clawed back` : "Sample wins shown until members' refunds land"}
        </div>
      </div>
      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="recovery-wall-grid">
        {data.wins.map((w, i) => (
          <div
            key={w.id}
            className="tactile-card rounded-md p-4 bg-[#141618] border border-[#282C30] relative overflow-hidden animate-in fade-in slide-in-from-bottom-2"
            style={{ animationDelay: `${i * 60}ms`, animationFillMode: "both" }}
            data-testid={`recovery-win-${w.id}`}
          >
            {w.sample && (
              <span className="absolute top-3 right-3 font-mono text-[9px] uppercase tracking-widest text-[#606872] border border-[#282C30] px-1.5 py-0.5 rounded-sm" data-testid={`recovery-win-sample-badge-${w.id}`}>sample</span>
            )}
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-md bg-[#00E676]/10 border border-[#00E676]/30 grid place-items-center font-display font-bold text-[#00E676]">{w.initial}</div>
              <div className="min-w-0">
                <div className="text-sm text-[#F4F1EA] truncate"><span className="font-semibold">{w.initial}***</span> got money back</div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-[#606872] truncate">{CHANNEL[w.channel] || "Refund"} · {ago(w.landed_at)}</div>
              </div>
            </div>
            <div className="mt-4 flex items-end justify-between gap-2">
              <div className="text-xs text-[#A0A7B0] truncate">{w.merchant}</div>
              <div className="font-display text-2xl font-bold text-[#00E676] tabular-nums flex items-center gap-1"><Undo2 className="h-4 w-4" />${w.amount.toFixed(2)}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
